// The folded side cards of a task group's page (S136): what each header says while folded.
import { plural } from "../../../helpers";

const p = plural("en");

export default {
  resources: {
    usage: (cpu: number, memory: number) => `${cpu}% of your CPU limit, ${memory}% of your memory limit`,
    restarting: "Restarting to apply the new size",
    pending: "New size applies when the current task finishes",
  },
  network: {
    allowed: (n: number, days: number) => `${p(n, { one: "# request", other: "# requests" })} allowed in the last ${p(days, { one: "day", other: "# days" })}`,
    blocked: (n: number, days: number) => `${p(n, { one: "# request", other: "# requests" })} blocked in the last ${p(days, { one: "day", other: "# days" })}`,
    window: (days: number) => `${days}d`,
  },
  costs: {
    total: (amount: string) => `${amount} spent in all`,
    trend: (days: number, today: string) => `Spend per day over the last ${days} days; today ${today}`,
  },
  requirements: {
    ready: (ready: number, total: number) => `${ready}/${total} ready`,
    detail: (ready: number, total: number) => `${ready} of ${p(total, { one: "# requirement", other: "# requirements" })} ready`,
    none: "None needed",
  },
  shared: {
    files: (n: number) => p(n, { one: "# file", other: "# files" }),
    more: (n: number) => `${n}+ files`,
    empty: "Empty",
    stopped: "VM stopped",
  },
};
